import { sendGAEvent } from '@next/third-parties/google'

import { classMap } from '@rewardops/services/src/services/analytics/events/google-event-builder'
import { EventParams } from '@rewardops/utils'

import { useApi } from './use-api'
import { useMemberUUID } from './use-member-uuid'

export const useAnalytics = () => {
  const { api, tenant } = useApi()
  const sendAnalyticsMutation = api.analytics.sendEvent.useMutation()
  const memberUUID = useMemberUUID()

  let sendEvent = (event: EventParams) => {}
  let sendGoogleAnalyticsEvent = (event: EventParams) => {}
  let sendCustomGoogleAnalyticsEvent = (event: any) => {}

  if (tenant?.analyticsEnabled) {
    sendEvent = (event: EventParams) => {
      sendAnalyticsMutation.mutateAsync(event)
    }

    sendGoogleAnalyticsEvent = (event: EventParams) => {
      const EventClass = classMap[event.type]
      if (!EventClass) {
        return
      }

      const enhancedData = {
        ...event.data,
        ...(memberUUID && { memberId: memberUUID }),
      }

      const paramsMapper = new EventClass(enhancedData)

      const data = paramsMapper.convertToGA4Format()

      sendGAEvent('event', event.type, data)
    }

    // TODO: consolidate both sendGoogleAnalyticsEvent and sendCustomGoogleAnalyticsEvent into one function
    // and refactor the code to use it consistently
    sendCustomGoogleAnalyticsEvent = (event: any) => {
      const enhancedData = {
        ...event.data,
        ...(memberUUID && { member_id: memberUUID }),
      }
      sendGAEvent('event', event.type, enhancedData)
    }
  }

  return { sendEvent, sendGoogleAnalyticsEvent, sendCustomGoogleAnalyticsEvent }
}
